function canFilter($scope, $location) {
    let f;
    $scope.f = {};
    if (f = $location.search().f) {
        _.each(f.split(' '), function(tag) {
            const kv = tag.split(':');
            const k = kv.shift();
            let v = (kv.length > 0 ? decodeURIComponent(kv.join(':')) : true);
            if (v[0] === '{') { v = JSON.parse(v); }
            return $scope.f[k] = v;
        });
    }

    $scope.filter = function(k, v) {
        if (k.indexOf('.') >= 0) {
            let context = $scope.f;
            const chain = k.split('.');
            while (context && (chain.length > 1)) {
                context = context[chain.shift()];
            }
            context[chain[0]] = v;
        } else {
            $scope.f[k] = v;
        }
        f = $scope.getFilterParam();
        return $location.search('f', f || undefined);
    };

    $scope.getFilterParam = function() {
        return _.map($scope.f, function(v, k) {
            if (v === true) {
                return k;
            } else if ((v === false) || (v === undefined)) {
                return "";
            } else {
                if (typeof(v) === 'object') { v = JSON.stringify(v); }
                return `${k}:${encodeURIComponent(v)}`;
            }
        }).sort().join(' ').replace(/\s\s+/g, ' ').trim();
    };
};

export { canFilter };


// WEBPACK FOOTER //
// ./mixins/can_filter.js